import axios from "axios";
import { appConstants } from "./appConstants";
import { loadingAction } from "ReduxReducers/loadingReducer";
import { IdleAction } from "ReduxReducers/tokenGenerateTime";
import { generateToken } from "./generic";

let axiosConfig = {
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("TOKEN")}`,
  },
}
let id;
if (JSON.parse(sessionStorage.getItem('LOGIN_DETAILS')) !== null) {
  id = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'))._id
}

export const SaveInvoice = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/addInvoice", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("Error while Saving: ", error?.response?.data?.Result_Message)

    })
}

export const getQuotationsForInvoice = async (values, callBack, dispatch) => {
  // dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/fetchQuotationData", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      // dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      // dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error getQuotationsForInvoice===>", error?.response?.data?.Result_Message)
    })
}

export const fetchInvoiceData = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/fetchInvoices", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()))
    }).catch(async error => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch)
      console.log("error fetchInvoiceData===>", error?.response?.data?.Result_Message)
    })
}
export const PreviewInvoiceDetails = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/previewInvoiceDetails", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()))
    }).catch(async error => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch)
      console.log("error PreviewInvoiceDetails===>", error?.response?.data?.Result_Message)
    })
}
export const getItemsForInvoice = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/fetchItemsForInvoice", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      // dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      // dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error getItemsForInvoice===>", error?.response?.data?.Result_Message)
    })
}
export const getInvoiceDetailsByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/fetchInvoiceDetailsByID", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") { generateToken(id, dispatch) }

      ;
      console.log("error getInvoiceDetailsByID===>", error?.response?.data?.Result_Message)
    })
}
export const UpdateInvoice = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/updateInvoice", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)

      console.log("Error while Updation: ", error?.response?.data?.Result_Message);

    })
}
export const deleteforInvoice = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/deleteInvoice", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      // dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      // dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error deleteInvoice===>", error?.response?.data?.Result_Message)
    })
}

export const ResendEmail = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/resendEmail", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)

      console.log("Error while Resend Email: ", error?.response?.data?.Result_Message);

    })
}

//RCTI

export const getSupplierForRCTI = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/fetchSupplierForRCTI", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error getSupplierForRCTI===>", error?.response?.data?.Result_Message)
    })
}

export const SaveRCTI = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/addRCTI", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error SaveRCTI===>", error?.response?.data?.Result_Message)

    })
}
export const UpdateRCTI = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/updateRCTI", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error UpdateRCTI===>", error?.response?.data?.Result_Message)

    })
}

export const getRCTIDetailsByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/fetchRCTIDetailsByID", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error getRCTIDetailsByID===>", error?.response?.data?.Result_Message)

    })
}

export const getRCTI = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/fetchRCTI", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error getRCTI===>", error?.response?.data?.Result_Message)

    })
}
export const deleteSelectedRCTI = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/deleteRCTI", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error deleteSelectedRCTI===>", error?.response?.data?.Result_Message)

    })
}
export const getRCTIByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/viewRCTIByID", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error getRCTIByID===>", error?.response?.data?.Result_Message)

    })
}

export const resendEmailRcti = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/resendEmailRcti", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)

      console.log("Error while Resend Email: ", error?.response?.data?.Result_Message);

    })
}


export const getFetchCustomerInvoiceBillDetails = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/FetchCustomerInvoiceBillDetails", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") { generateToken(id, dispatch) }

      ;
      console.log("error getFetchCustomerInvoiceBillDetails===>", error?.response?.data?.Result_Message)
    })
}


export const getDefaultInvoiceDueDate = async (values, callBack, dispatch) => {
  // dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/fetchDefaultInvoiceDueDate", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      // dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      // dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") { generateToken(id, dispatch) }

      ;
      console.log("error getDefaultInvoiceDueDate===>", error?.response?.data?.Result_Message)
    })
}
export const getDefaultRCTIDueDate = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/fetchDefaultRCTIDueDate", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") { generateToken(id, dispatch) }

      ;
      console.log("error getDefaultRCTIDueDate===>", error?.response?.data?.Result_Message)
    })
}


export const submitInvoicePayment = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  await axios.post(appConstants.baseURL + 'invoice/submitInvoicePaymentDetails', values, axiosConfig)
    .then((res) => {
      dispatch(loadingAction(false));
      callBack(res.data);
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      console.log("submitInvoicePayment:", error);
      if (error?.response?.data?.Result_Message === "TokenExpiredError") { generateToken(id, dispatch) }
    });
}

export const getCutomerInvoiceStatement = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  await axios.post(appConstants.baseURL + 'invoice/fetchCutomerInvoiceStatement', values, axiosConfig)
    .then((res) => {
      dispatch(loadingAction(false));
      callBack(res.data);
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      console.log("fetchCutomerInvoiceStatement:", error);
      if (error?.response?.data?.Result_Message === "TokenExpiredError") { generateToken(id, dispatch) }
    });
}

export const downloadRCTI = async (values, callback, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/rctiDownload", values, axiosConfig)
    .then((res) => {
      callback(res)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error rctiDownload===>", error?.response?.data?.Result_Message)
      console.log(error)
    })
}
export const PreviewRCTIDetails = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoice/previewRCTIDetails", values, axiosConfig)
    .then((res) => {
      console.log('sss', res)
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()))
    }).catch(async error => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch)
      console.log("error previewRCTIDetails===>", error?.response?.data?.Result_Message)
    })
}


// Credit Functionalities

export const SaveCredit = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "credit/addCredit", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("Error while addCredit: ", error?.response?.data?.Result_Message)

    })
}

export const UpdateCredit = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "credit/updateCredit", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)

      console.log("Error while Updation: ", error?.response?.data?.Result_Message);

    })
}

export const getCreditDetailsByID = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "credit/fetchCreditDetailsByID", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") { generateToken(id, dispatch) }

      ;
      console.log("error fetchCreditDetailsByID===>", error?.response?.data?.Result_Message)
    })
}

export const ResendEmailCredit = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "credit/resendEmailCredit", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)

      console.log("Error while resendEmailCredit: ", error?.response?.data?.Result_Message);

    })
}

export const PreviewCreditDetails = async (values, callBack, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "credit/previewCreditDetails", values, axiosConfig)
    .then((res) => {
      callBack(res.data)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()))
    }).catch(async error => {
      dispatch(loadingAction(false));
      generateToken(id, dispatch)
      console.log("error previewCreditDetails===>", error?.response?.data?.Result_Message)
    })
}

export const downloadCredit = async (values, callback, dispatch) => {
  dispatch(loadingAction(true));
  axios.post(appConstants.baseURL + "invoicePdfFormat/downloadCredit", values, axiosConfig)
    .then((res) => {
      callback(res)
      dispatch(loadingAction(false));
      dispatch(IdleAction(new Date()));
    }).catch(async error => {
      dispatch(loadingAction(false));
      if (error?.response?.data?.Result_Message === "TokenExpiredError") generateToken(id, dispatch)
      console.log("error downloadInvoice===>", error?.response?.data?.Result_Message)
      console.log(error)
    })
}